import React from 'react';
import { Link } from 'gatsby';
import { trailingSlash } from '../../utils';

const SendGridLink = ({ children, to, ...props }) => {
  /**
   * "white listed" routes
   */
  const awsRoutes = ['/product-tour', '/videos', '/solutions'];

  /**
   * Strip sendgrid.com from __to__
   */
  const uri = to ? trailingSlash(
    to.replace(/https?:\/\/(www.|staging.)?sendgrid.com\//, '/')
  ) : null;

  /**
   * Check if __uri__ starts with a whitelisted route.
   */
  const match = uri ? awsRoutes.some((route) => uri.startsWith(route)) : null;

  /**
   * If hasMatch return Gatsby Link.
   */
  if (match) {
    return (
      <Link {...props} to={uri}>
        {children}
      </Link>
    );
  }

  /**
   * If no match, just return anchor with all props.
   */
  return (
    <a href={uri} {...props}>
      {children}
    </a>
  );
};

export default SendGridLink;
